module.exports = __webpack_public_path__ + "img/icon_name-01.c8b52b64.svg";